<template>
  <a-modal
    ref="model"
    centered
    title="会员充值"
    v-model="visible"
    width="70%"
    okText="确认"
    :footer="null"
    @cancel="onCancel"
    :maskClosable="false"
    :destroyOnClose="true"
    :bodyStyle="{ paddingTop: 0 }"
  >
    <div class="content">
      <a-card title="基本信息" :bordered="true" style="margin-top:24px">
        <dataForm
          :colnum="2"
          :data="baseData"
          :content="baseContent"
          :labelCol="8"
          :wrapperCol="16"
          ref="baseForm"
          :showButton="false"
        >
        </dataForm>
      </a-card>
      <a-card
        title="会员信息"
        :bordered="true"
        style="margin-top:24px;margin-bottom:24px"
      >
        <dataForm
          :colnum="2"
          :data="memberData"
          :content="memberContent"
          :labelCol="8"
          :wrapperCol="16"
          ref="memberForm"
          :showButton="false"
        >
        </dataForm>
      </a-card>
    </div>
    <div class="form-action">
      <a-button type="primary" @click="onSubmit" :loading="confirmLoading"
        >确认</a-button
      >
      <a-button @click="onCancel">取消</a-button>
    </div>
  </a-modal>
</template>
<script>
import { cache } from "@/utils/common.js";
import calc from "@/utils/calc";
// import clone from "lodash/clone";
import dataForm from "@/components/dataForm/DataForm";
import moment from "moment";
moment.locale("zh-cn");
export default {
  name: "MemberCharge",
  components: {
    dataForm
  },
  data() {
    return {
      id: 0,
      confirmLoading: false,
      visible: false,
      baseContent: [],
      memberContent: [],
      baseData: {},
      memberData: {},
      payMethod: {},
      //充值方案
      MemberRechargePlan: null
    };
  },
  created() {
    this.user = cache.get("user");
    var url = {
      MemberInfoGetDetail: "MemberInfoGetDetail",
      MemberRecharge: "MemberRecharge"
    };
    if (this.user.IsGroupSystem) {
      for (let i in url) {
        url[i] = "Group" + url[i];
      }
    }
    this.url = url;
  },
  mounted() {},
  methods: {
    init() {
      let _this = this;
      //基本信息
      this.baseContent = [
        {
          label: "充值金额",
          type: "number",
          name: "Amount",
          min: 0,
          props: {
            message: "请输入充值金额",
            precision: 2
          },
          option: {
            rules: [{ required: true, message: "请输入充值金额" }]
          },
          onChange: value => {
            let data = _this.$refs.baseForm.getData();
            data.Amount = value ? value : 0;
            _this.amountChange(data);
          }
        },
        {
          label: "赠送金额",
          type: "number",
          min: 0,
          name: "PresentAmount",
          props: {
            precision: 2
          },
          option: {
            rules: [{ required: true, message: "请输入赠送金额" }]
          },
          onChange: value => {
            let data = _this.$refs.baseForm.getData();
            data.PresentAmount = value ? value : 0;
            _this.dataChange(data);
          }
        },
        {
          label: "充值方式",
          type: "select",
          name: "PaywayId",
          defaultSelect: true,
          api: "GetMemberRechargeList", //请求接口api
          textField: "Name", //可选项数据文本字段
          props: {},
          option: {
            rules: [{ required: true, message: "请输入充值方式" }]
          },
          load: data => {
            return (data || []).filter(
              el =>
                !(
                  (el.Attributes & 134217728) > 0 ||
                  (el.Attributes & 268435456) > 0
                )
            );
          },
          onChange: (value, sel) => {
            _this.changePayWay(value, sel);
          }
        },
        {
          label: "赠送积分",
          type: "number",
          min: 0,
          name: "PresentPoint",
          props: {
            precision: 2
          },
          option: {
            rules: [{ required: true, message: "请输入赠送积分" }]
          },
          onChange: value => {
            let data = _this.$refs.baseForm.getData();
            data.PresentPoint = value ? value : 0;
            _this.dataChange(data);
          }
        },
        {
          label: "授权码",
          placeholder: "请输入备注",
          type: null,
          name: "AuthCode",
          option: {
            rules: [{ required: true, message: "请输入授权码" }]
          },
          pressEnter: () => {
            this.onSubmit();
          }
        },
        {
          label: "备注",
          placeholder: "请输入备注",
          name: "Remark",
          colnum: 2,
          labelCol: 4,
          wrapperCol: 20,
          props: {}
        }
      ];
      this.memberContent = [
        {
          label: "卡号",
          placeholder: "请输入卡号",
          name: "CardNo",
          props: {
            disabled: true
          }
        },
        {
          label: "姓名",
          placeholder: "请输入姓名",
          name: "Name",
          props: {
            disabled: true
          }
        },
        {
          label: "当前余额",
          type: "number",
          name: "Balance",
          props: {
            disabled: true,
            precision: 2
          }
        },
        {
          label: "充值后余额",
          type: "number",
          name: "afterBalance",
          props: {
            disabled: true,
            precision: 2
          }
        },
        {
          label: "当前积分",
          type: "number",
          name: "PointBalance",
          props: {
            disabled: true,
            precision: 2
          }
        },
        {
          label: "充值后积分",
          type: "number",
          name: "afterPointBalance",
          props: {
            disabled: true,
            precision: 2
          }
        }
      ];
    },
    changePayWay(value, sel) {
      this.payMethod = sel;
      const item = this.baseContent.find(el => el.name == "AuthCode");
      if (
        sel &&
        ((sel.Attributes & 2097152) > 0 || (sel.Attributes & 4194304) > 0)
      ) {
        //通联支付
        item.type = "input";
      } else {
        item.type = null;
      }
    },
    dataInit() {
      this.baseData = {
        Amount: 0,
        PresentAmount: 0,
        PresentPoint: 0
      };
    },
    show(id = 0) {
      this.id = id;
      this.init();
      this.visible = true;
      this.dataInit();
      this.$post(this.url.MemberInfoGetDetail, {
        Id: id
      }).then(res => {
        let data = res.Data;
        let MemberRechargePlan = data.MemberRechargePlan;
        data.afterBalance = data.Balance;
        data.afterPointBalance = data.PointBalance;
        this.MemberCardId = data.Id;
        this.memberData = data;
        this.MemberRechargePlan = MemberRechargePlan;
        this.$refs.memberForm.updateData();
      });
    },
    amountChange(data) {
      let MemberRechargePlan = this.MemberRechargePlan;
      if (MemberRechargePlan) {
        if (MemberRechargePlan.AmountPresentId == 0) {
          data.PresentAmount = MemberRechargePlan.PresentAmount;
        } else {
          data.PresentAmount = calc(data.Amount)
            .multiply(MemberRechargePlan.PresentAmount)
            .divide(100)
            .number(2);
        }

        if (MemberRechargePlan.PointPresentId == 0) {
          data.PresentPoint = MemberRechargePlan.PresentPoint;
        } else {
          data.PresentAmount = calc(data.Amount)
            .multiply(MemberRechargePlan.PresentPoint)
            .divide(100)
            .number(2);
        }
      }
      this.dataChange(data);
    },
    dataChange(data) {
      this.$refs.baseForm.form.setFieldsValue({
        PresentAmount: data.PresentAmount,
        PresentPoint: data.PresentPoint
      });
      this.$refs.memberForm.form.setFieldsValue({
        afterBalance:
          Math.round(
            parseInt(this.memberData.Balance) * 100 +
              data.PresentAmount * 100 +
              data.Amount * 100
          ) / 100,
        afterPointBalance:
          Math.round(
            parseInt(this.memberData.PointBalance) * 100 +
              data.PresentPoint * 100
          ) / 100
      });
    },
    onSubmit() {
      this.$refs.baseForm
        .getData(true)
        .then(formData => {
          if (
            formData.Amount <= 0 &&
            formData.PresentAmount <= 0 &&
            formData.PresentPoint <= 0
          ) {
            this.$message.error(
              "充值金额、赠送金额、赠送积分必须有一项值大于0"
            );
            return false;
          }
          if (
            this.payMethod &&
            ((this.payMethod.Attributes & 2097152) > 0 ||
              (this.payMethod.Attributes & 4194304) > 0) &&
            (formData.AuthCode.trim().length < 15 ||
              formData.AuthCode.trim().length > 20)
          ) {
            this.$message.error("请填写正确的授权码");
            return false;
          }
          let params = {
            MemberCardId: this.MemberCardId,
            MemberRechargePlanId: this.MemberRechargePlan
              ? this.MemberRechargePlan.Id
              : 0,
            Category: 1,
            PointCategory: 1,
            ...formData
          };
          this.confirmLoading = true;
          this.$post(this.url.MemberRecharge, params)
            .then(res => {
              if (res.Data) {
                this.$message.success("充值成功");
                this.visible = false;
                this.$emit("submit");
              } else {
                this.$message.error("提交出错,请重试");
              }
              this.confirmLoading = false;
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        })
        .catch(() => {
          this.$message.error("请完成填写表单");
        });
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.form-action {
  text-align: center;
  .ant-btn {
    margin-right: 10px;
  }
}

.content {
  height: calc(100vh - 350px);
  overflow-y: auto;
}

/deep/.ant-modal-body {
  padding: 10px 20px;
}
/deep/ .ant-card-head {
  min-height: 38px;
  background: #fafafa;
  .ant-card-head-title {
    padding: 5px 0;
  }
}
/deep/ .ant-card-wider-padding .ant-card-body {
  padding: 15px 32px;
}
</style>
